<template>
    <div id="app" :class="themeClassName">
        <Layout>
            <Header v-if="isAuthorized && isClientSelected" class="hoxton-header">
                <Navigation />
            </Header>
            <Layout>
                <Sider
                    collapsible
                    hide-trigger
                    class="sidebarWrapper"
                    :model-value="!isSidebarOpen"
                    :collapsed-width="sidebarWidthCollapsed"
                    :width="sidebarWidthOpen"
                >
                    <portal-target name="main-sidebar" />
                </Sider>
                <Content class="main-content">
                    <router-view :key="$route.fullPath" class="hox-full-width router-view" />
                </Content>
            </Layout>
        </Layout>
        <div v-if="isAuthorized && !isHeaderHidden" class="hoxton-footer">
            <footer-nav theme="light" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Navigation from "@/components/Navigation.vue";
import FooterNav from "@/FooterNav.vue";
import { useSidebar } from "@/composables/useSidebar";
import { useUser } from "@/composables/useUser";
import { useTheme } from "@/composables/useTheme";

export default defineComponent({
    name: "ThemeDefault",
    components: {
        FooterNav,
        Navigation
    },

    setup() {
        const { isSidebarOpen, sidebarWidthCollapsed, sidebarWidthOpen, setSidebarWidthOpen } = useSidebar();
        const { isAuthorized } = useUser();
        const { themeClassName } = useTheme();

        void setSidebarWidthOpen(250);

        return {
            themeClassName,
            isAuthorized,
            isSidebarOpen,
            sidebarWidthCollapsed,
            sidebarWidthOpen
        };
    },

    computed: {
        isClientSelected() {
            return "clientId" in this.$route.params;
        },

        isHeaderHidden() {
            return this.$route.meta.hideHeader;
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.theme-default {
    .ivu-layout-sider {
        left: auto;
    }
}

.hoxton-footer {
    position: sticky;
    left: 0;
    bottom: 0;
    padding-left: $spacing-small;
    width: $campaign-vertical-nav-width;
    z-index: $zindex-footer;
}
</style>
